import script from "./GaokaoDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./GaokaoDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./GaokaoDrawer.vue?vue&type=style&index=0&id=02130913&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02130913"]])

export default __exports__